module.exports = __webpack_public_path__ + "static/media/pic17.880348d7.jpg";